import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=58bb837b&scoped=true&"
import script from "./subscription.vue?vue&type=script&lang=js&"
export * from "./subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb837b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bb837b')) {
      api.createRecord('58bb837b', component.options)
    } else {
      api.reload('58bb837b', component.options)
    }
    module.hot.accept("./subscription.vue?vue&type=template&id=58bb837b&scoped=true&", function () {
      api.rerender('58bb837b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/subscription.vue"
export default component.exports